var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStswTokenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "stsw-token-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 150h150V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stsw-token-logo_svg__a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 75c0-41.421-33.579-75-75-75S0 33.579 0 75s33.579 75 75 75 75-33.579 75-75",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.098 97.813l-11.14-11.614-11.212 11.686h-8.184l15.306-15.95-3.486-3.633c-2.983-3.11-5.967-6.22-8.953-9.328-2.757-2.868-5.503-5.632-8.784-7.918a16.875 16.875 0 00-9.693-3.035c-9.358 0-16.973 7.61-16.982 16.966.009 9.357 7.624 16.967 16.982 16.967 3.489 0 6.84-1.05 9.692-3.036 3.282-2.287 6.028-5.05 8.785-7.919l1.626-1.693 4.109 4.245-1.477 1.54c-2.97 3.09-5.944 6.077-9.667 8.672a22.765 22.765 0 01-13.068 4.095c-12.61 0-22.87-10.25-22.887-22.857v-.03c.017-12.606 10.277-22.856 22.887-22.856 4.703 0 9.222 1.416 13.068 4.095 3.723 2.594 6.697 5.582 9.667 8.673 2.987 3.11 5.972 6.22 8.956 9.33L89.36 93.725c.388.405 1.396 1.45 2.404 2.493l1.608 1.666h-8.205l-.07-.072M64.902 52.188L76.042 63.8l11.211-11.684h8.185l-15.306 15.95 3.486 3.632c2.983 3.11 5.967 6.22 8.953 9.328 2.757 2.868 5.503 5.632 8.784 7.918a16.875 16.875 0 009.693 3.035c9.358 0 16.973-7.61 16.982-16.966-.009-9.357-7.624-16.967-16.982-16.967-3.489 0-6.84 1.05-9.692 3.036-3.282 2.286-6.028 5.05-8.785 7.918l-1.626 1.695-4.11-4.246 1.478-1.54c2.97-3.09 5.944-6.077 9.667-8.672a22.765 22.765 0 0113.068-4.095c12.61 0 22.87 10.25 22.887 22.857v.03c-.017 12.606-10.278 22.856-22.887 22.856a22.753 22.753 0 01-13.068-4.096c-3.723-2.593-6.697-5.581-9.667-8.672-2.987-3.11-5.972-6.22-8.956-9.33L60.64 56.273c-.388-.404-1.396-1.448-2.404-2.492l-1.608-1.666h8.205l.07.071",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStswTokenLogo);
export default __webpack_public_path__ + "static/media/stsw-token-logo.d46023a51e2287f553cd673cd9ee0aa5.svg";
export { ForwardRef as ReactComponent };